import { CostArgs } from '../../../../utils'
import { QuebecPurchaseTaxes } from '../purchase-taxes'
import { MontrealWelcomeTax } from './expense'

export const PurchaseTaxes = (args: CostArgs) =>
  ({
    ...QuebecPurchaseTaxes(args),
    welcomeTax: MontrealWelcomeTax,
  } as const)
